export default class {

  constructor() {

    if (true === CSS.supports('aspect-ratio', '1/1')) {
      return;
    }

    /**
     * Equalize elements in width and height.
     */
    this.elements = document.getElementsByClassName('js-equalsize');
    this.loop();
  }

  loop() {
    [...this.elements].forEach(element => {
      if (element.clientWidth < element.clientHeight) {
        element.style.maxHeight = element.clientWidth + 'px';
      } else if (element.clientWidth > element.clientHeight) {
        element.style.maxWidth = element.clientHeight + 'px';
      }
    });
  }
}
